import React from "react";
import { useTheme } from "styled-components";

const RecentlyActive = () => {
  const theme = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.125 11.087a4.782 4.782 0 1 0-5.055 0c-1.452.475-2.759 1.363-3.81 2.613a.563.563 0 1 0 .862.725c1.411-1.685 3.356-2.613 5.472-2.613 2.115 0 4.06.928 5.475 2.613a.563.563 0 0 0 .861-.725c-1.05-1.25-2.357-2.138-3.805-2.613M3.938 7.03a3.656 3.656 0 1 1 7.312 0 3.656 3.656 0 0 1-7.312 0m13.897 2.367-2.25 2.25a.56.56 0 0 1-.795 0l-1.125-1.125a.563.563 0 1 1 .796-.796l.726.728 1.853-1.853a.563.563 0 1 1 .796.796"
        fill={theme.text.text}
      />
    </svg>
  );
};

export default RecentlyActive;
